module.exports = __webpack_public_path__ + "img/cvs-basic-dp.22e30c1b.svg";